// extracted by mini-css-extract-plugin
module.exports = {"tc":"Tc_tc__F9Dh4"};